// Re-export all navigation functions from useNavigation hook
export * from "./useNavigation";

// request paths
export const archiveDocumentationsURL = "/api/users/archives/documents/";
export const archiveExaminationsURL = "/api/users/archives/examinations/";
export const changePasswordURL = "/api/users/password_change/";
export const changePasswordExpiredURL = "/api/users/password_change_expired/";
export const changePinURL = "/api/users/pin_change/";
export const directoriesURL = "/api/users/directories/";
export const drivingLicenseURL = "/api/users/driving-license-categories/";
export const examinationURL = "/api/core/examinations/";
export const examinationMultiURL = "/api/core/examinations/create-multi/";
export const examineesURL = "/api/users/examinees/";
export const bulkDeleteExamineesURL = "/api/users/examinees/bulk-delete/";
export const getPsychologicalLabInfoURL = "/api/users/psych-lab-info/";
export const getResetPasswordEmailURL = "/api/users/password_reset/";
export const legalBasisURL = "/api/core/legal_bases/";
export const licensedMethodologiesURL = "/api/core/licensed_methodologies/";
export const moveExamineesURL = "/api/users/examinees/relocate-examinees/";
export const psychologicalTestsURL = "/api/core/tests/";
export const resetPasswordSendRequestURL = "/api/users/password_reset/confirm/";
export const getContractURL = "/api/users/contract/";
export const normSetURL = "/api/core/norms/";
export const psychologicalLabsGrantedURL = "/api/users/admin_labs_granted/";
export const psychologicalLabsURL = "/api/users/psychlabs/";
export const psychologicalLabsUserURL = "/api/users/psychlabs_users/";
export const psychologicalLabsActivityURL = "/api/users/psychlabs_activity/";
export const psychologicalLabsLicenceURL = "/api/users/psychlabs_license/";
export const psychologicalUserURL = "/api/users/psych_user/";
export const exportResultsURL = "/api/users/export_results/";
export const registryURL = "/api/users/registry/";
export const sendEmailURL = "/api/users/send_email/";
export const psychologicalMethodologyTestCategories = "/api/users/methodology/";
export const psychologicalTestTypes = "/api/users/test_types/";

// gatsby pages' paths
export const archiveExaminationPath = "/app/archive-examination";
export const addExamineePath = "/app/add-examinee";
export const importExamineesPath = "/app/import-examinees";
export const addPsychLabPath = "/app/add-psychlab";
export const addPsychLabUserPath = "/app/add-psychuser";
export const dashboardPath = "/app/dashboard";
export const dashboardAdminPath = "/app/admin-dashboard";
export const diagnosticReportPath = "/app/documentation/diagnostic-report";
export const directoriesPath = "/app/directories";
export const editExamineePath = "/app/edit-examinee";
export const examinationPath = "/app/examination";
export const examinationAssignmentPath = "/app/examination-assignment";
export const examineePath = "/app/examinee";
export const psychLabPath = "/app/psychlab";
export const editPsychUserPath = "/app/edit-psychuser/";
export const expiredPasswordPath = "/expiredPassword";
export const helpdeskPath = "/helpdesk";
export const cookiesPolicyPath = "/cookiespolicy/";
export const helpdeskDocumentPath = "/app/helpdesk/documents";
export const interpretationReportPath =
  "/app/documentation/interpretation-report";
export const resetPasswordGetEmailPath = "/getResetPasswordEmail";
export const searchPath = "/app/search";
export const searchAdminPath = "/app/admin-search";
export const userSettingsPath = "/app/user-settings";
export const adminSettingsPath = "/app/admin-settings";
export const adminExportResultsPath = "/app/admin-export";
export const adminPriceListPath = "/app/admin-pricelist";
export const adminEmailSenderPath = "/app/email-sender";
export const userExportResultsPath = "/app/user-export";
export const userRegistryPath = "/app/user-registry";
export const adminRegistryPath = "/app/admin-registry";
export const userSummaryPath = "/app/user-summary";
export const adminSummaryPath = "/app/admin-summary";
export const userImportExamineesPath = "/app/import-examinees";
export const remoteHelpPath =
  "https://anydesk.com/pl/downloads/windows?dv=win_exe";

// Navigation functions are now available through useNavigation hook
// Import and use the hook in your components:
// import { useNavigation } from "../utils/useNavigation";
// const { handleNavigateToPreviousPage, handleNavigateToPage, ... } = useNavigation();

export const API_PATHS = {
  // ... existing paths ...
  TWO_FACTOR: {
    SETUP: "/api/users/setup_2fa/",
    VERIFY_SETUP: "/api/users/verify_2fa_setup/",
    DISABLE: "/api/users/disable_2fa/",
    VERIFY: "/api/users/verify_2fa/",
    VERIFY_LOGIN: "/api/users/verify-2fa/",
  },
} as const;